import React, { useState } from "react";
import "./Login.css";
import { Link, useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { Spinner } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { singUp } from "../../../../redux/reduxApi/SingIn&SingUp/SingUpApi";
import toast from "react-hot-toast";
import { singIn } from "../../../../redux/reduxApi/SingIn&SingUp/SinginApi";
import { FcGoogle } from "react-icons/fc";
// import {
//   signInWithGoogle,
//   storeDataAfterGoogelSingin,
// } from "../../../../redux/reduxApi/SingIn&SingUp/SingInWithGoogelApi";
import hero from "../../../../../assets/windTree/images/login/gp-brown.webp";
import Button from "../../../../ui/Button.jsx";
import Heading from "../../utils/Heading";
import { useLocation } from "react-router-dom";
import NavBar from "../../../../navbar/Navbar";
import { useEffect } from "react";
import { getCartProductsWebuser } from "../../../../redux/reduxApi/website/CartProductCount.jsx";
import { getWishlistProducts } from "../../../../redux/reduxApi/website/WishlistApi.jsx";
import { addToCartApi } from "../../../../redux/api/website/Addtocartapi.jsx";
import { getMotorsList } from "../../../../redux/reduxApi/admin/MotorizationReduxApi.jsx";
import { getShadeDetailById } from "../../../../redux/api/admin/shadeApi.jsx";
// import defaultImg from "../../../../assets/windTree/images/login/loginlogo.webp";

const Login = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const panel = queryParams.get("panel");
  const [isRightPanelActive, setIsRightPanelActive] = useState(
    panel === "signup",
  );
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    remember: false,
    customerType: "USER",
    gstNumber: "",
    companyName: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [animateEntrance, setAnimateEntrance] = useState(false);
  const [animateToggle, setAnimateToggle] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userType, setUserType] = useState("USER");
  
  // Flag to prevent multiple auto-add attempts
  const [autoAddCompleted, setAutoAddCompleted] = useState(false);
  
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      customerType: userType,
    }));
  }, [userType]);

  const handleUserTypeChange = (e) => {
    const value = e.target.value.toUpperCase();
    setUserType(value);

    setFormData((prev) => ({
      ...prev,
      customerType: value,
    }));
  };

  useEffect(() => {
    setAnimateEntrance(true);
  }, []);

  const togglePanel = (value) => {
    setAnimateToggle(true);
    setTimeout(() => {
      setIsRightPanelActive(value);
      setAnimateToggle(false);
    }, 300);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };

      if (name === "countryCode" || name === "mobileNumber") {
        updated.phone = `${updated.countryCode || ""}${updated.mobileNumber || ""}`;
      }

      return updated;
    });
  };

  // Function to calculate area (same logic as in ProductDetailPage)
  const calculateAreaFn = (height, width, unit) => {
    const inchesToSqFt = (widthInch, dropInch) => {
      const adjustedDrop = dropInch < 39.37 ? 39.37 : dropInch;
      const area = (widthInch * adjustedDrop) / 144;
      return dropInch === 0 ? 0 : area;
    };
    
    const mmToSqFt = (widthMm, dropMm) => {
      if (dropMm === 0) return 0;
      const effectiveDrop = dropMm < 1000 ? 1000 : dropMm;
      const initialValue = widthMm * effectiveDrop * 0.000001;
      const adjustedValue = initialValue < 1 ? 1 : initialValue;
      return adjustedValue * 10.764;
    };
    
    const cmToSqFt = (widthCm, dropCm) => {
      if (dropCm === 0) return 0;
      const effectiveDrop = dropCm < 100 ? 100 : dropCm;
      const initialValue = widthCm * effectiveDrop * 0.0001;
      const adjustedValue = initialValue < 1 ? 1 : initialValue;
      return adjustedValue * 10.764;
    };
    
    const h = Number(height) || 0;
    const w = Number(width) || 0;
    if (h <= 0 || w <= 0) return 0;
    
    switch (unit) {
      case "inch": return inchesToSqFt(w, h);
      case "mm": return mmToSqFt(w, h);
      case "cm": return cmToSqFt(w, h);
      default: return 0;
    }
  };

  // Auto add to cart function
  const autoAddToCartAfterLogin = async () => {
    const pendingProductData = localStorage.getItem('pendingProductData');
    const userId = localStorage.getItem("UserRowId");
    
    // Check if there's pending data, user is logged in, and auto-add hasn't been completed
    if (pendingProductData && userId && !autoAddCompleted) {
      console.log("Auto-add triggered with data:", pendingProductData);
      
      try {
        const productData = JSON.parse(pendingProductData);
        console.log("Parsed product data:", productData);
        
        // Fetch product details to get current price and data
        const response = await getShadeDetailById(productData.shadeDataId);
        const shadeDataResponse = response?.data?.data?.shade;
        console.log("Shade data response:", shadeDataResponse);
        
        if (shadeDataResponse) {
          const selectedItem = shadeDataResponse.items?.find(item => item.ROWID === productData.selectedItemId);
          console.log("Selected item:", selectedItem);
          
          if (selectedItem) {
            // Get motor data if needed
            let motorRowId = "";
            let motorPrice = 0;
            
            if (productData.motorization === "Yes" && productData.motorType) {
              const motorsResponse = await dispatch(getMotorsList());
              const motorData = motorsResponse?.payload?.data?.motors || [];
              const selectedMotor = motorData.find(m => m.motorName === productData.motorType);
              motorRowId = selectedMotor?.ROWID || "";
              motorPrice = parseFloat(selectedMotor?.motorPrice) || 0;
              console.log("Motor selected:", selectedMotor);
            }
            
            const itemPrice = parseFloat(selectedItem?.sellingPrice) || 0;
            const shadePrice = parseFloat(shadeDataResponse?.sellingPrice) || 0;
            const sellingPrice = itemPrice + shadePrice;
            const calculatedArea = calculateAreaFn(productData.height, productData.width, productData.unit);
            
            // Calculate final price
            let finalPrice = calculatedArea * sellingPrice * productData.quantity;
            if (productData.motorization === "Yes" && motorPrice > 0) {
              finalPrice += motorPrice * productData.quantity;
            }
            
            // Get display images
            let displayImages = [];
            if (shadeDataResponse?.shadeMedia?.length > 0) {
              displayImages = shadeDataResponse.shadeMedia;
            } else if (selectedItem?.itemImage) {
              try {
                displayImages = JSON.parse(selectedItem.itemImage);
              } catch (e) {
                console.error("Error parsing itemImage:", e);
                displayImages = [];
              }
            }
            
            const cartData = {
              accountId: userId,
              productId: selectedItem?.ROWID || "",
              quantity: productData.quantity.toString(),
              price: sellingPrice.toString(),
              shadeNo: shadeDataResponse?.shadeNo || "Product",
              itemName: selectedItem?.itemName || "",
              image: displayImages[0],
              height: productData.height.toString(),
              width: productData.width.toString(),
              unit: productData.unit,
              measurements: productData.unit,
              status: "Active",
              motorization: productData.motorization,
              sideOfControl: productData.sideOfControl,
              mechanismColor: productData.mechanismColor || "white",
              remarks: productData.remarks || "",
              area: calculatedArea.toString(),
              taxRate: (selectedItem?.tax || 0).toString(),
              subtotal: (calculatedArea * sellingPrice * productData.quantity).toString(),
              sellingPricePerUnit: sellingPrice.toString(),
              motorType: motorRowId,
              total: finalPrice.toString(),
            };
            
            console.log("Auto-adding to cart with data:", cartData);
            
            // Add to cart
            const addResponse = await addToCartApi(cartData);
            console.log("Add to cart response:", addResponse);
            
            if (addResponse.data.success) {
              toast.success("Product added to cart successfully!");
              localStorage.removeItem('pendingProductData');
              localStorage.removeItem('redirectAfterLogin');
              setAutoAddCompleted(true);
              
              // Navigate to cart after successful add
              setTimeout(() => {
                navigate("/addtocart");
              }, 200);
            } else {
              toast.error("Failed to add product to cart");
            }
          } else {
            console.error("Selected item not found");
            toast.error("Product configuration not found");
          }
        } else {
          console.error("Shade data not found");
          toast.error("Product details not found");
        }
      } catch (error) {
        console.error("Error auto-adding product to cart:", error);
        toast.error("Failed to add product to cart. Please try again.");
        // Don't remove pending data so user can try again manually
      }
    }
  };

  const fetchUserCartAfterLogin = async () => {
    try {
      const userId = localStorage.getItem("UserRowId");
      if (userId) {
        console.log("Fetching cart for user after login:", userId);
        const resp = await dispatch(getCartProductsWebuser());
        return resp;
      }
    } catch (error) {
      console.error("Error fetching cart after login:", error);
    }
  };

  const wishlistData = useSelector(
    (state) => state.Wishlist?.WishListProducts?.wishlist || [],
  );
  const wishlistCount = wishlistData.length;
  console.log("wishlistCount", wishlistCount);
  
  const fetchWishlist = async () => {
    try {
      // setIsLoading(true);
      await dispatch(getWishlistProducts());
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    } finally {
      // setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchWishlist();
  // }, [dispatch]);

  const handleSignin = async (e) => {
    e.preventDefault();
    if (!formData.email || !formData.password) {
      toast.error("Email and password are required");
      return;
    }
    setIsLoading(true);
    try {
      const response = await dispatch(singIn(formData));
      if (response.meta.requestStatus === "fulfilled") {
        if (response.payload?.data?.success) {
          toast.success("Login Successfully");
          console.log("Login response:", response.payload.data.data);
          
          const userData = response.payload.data.data.webuser.ROWID;
          const userEmail = response.payload.data.data.webuser.email;
          
          localStorage.setItem("loggedCustomer", userData);
          localStorage.setItem("UserRowId", userData);
          localStorage.setItem("userEmail", userEmail);
          localStorage.setItem("user", JSON.stringify(userData));
          
          await fetchUserCartAfterLogin();
          await fetchWishlist();
          
          // Check for pending product data AFTER login is complete
          const pendingProductData = localStorage.getItem('pendingProductData');
          const redirectPath = localStorage.getItem("redirect");
          
          if (pendingProductData) {
            // Call auto-add after a short delay to ensure everything is initialized
            setTimeout(() => {
              autoAddToCartAfterLogin();
            }, 500);
          } else {
            navigate(redirectPath || "/homepage");
          }
        } else {
          setIsLoading(false);
          toast.error(response.payload?.data?.message || "Login failed");
        }
      } else if (response.meta.requestStatus === "rejected") {
        setIsLoading(false);
        const errorMessage =
          response.payload?.message ||
          response.payload?.data?.message ||
          "Login failed";
        toast.error(errorMessage);
        if (response.payload?.status === 401) {
          console.log("Invalid email or password");
        } else if (response.payload?.status === 403) {
          toast.error("Account not verified. Please verify your email first.");
        }
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("An unexpected error occurred");
      console.error("Login error:", error);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Basic frontend validation
    if (
      !formData.firstName ||
      !formData.lastName ||
      !formData.email ||
      !formData.phone ||
      !formData.password
    ) {
      setIsLoading(false);
      toast.error("All fields are required");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setIsLoading(false);
      toast.error("Please enter a valid email address");
      return;
    }

    // Mobile number validation (basic)
    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(formData.phone)) {
      setIsLoading(false);
      toast.error("Please enter a valid 10-digit mobile number");
      return;
    }

    // Password validation (min 6 chars)
    if (formData.password.length < 6) {
      setIsLoading(false);
      toast.error("Password must be at least 6 characters long");
      return;
    }

    try {
      const response = await dispatch(singUp(formData));
      if (response.meta.requestStatus === "fulfilled") {
        if (response.payload?.data?.success) {
          setIsLoading(false);
          toast.success(response.payload.data.message || "Signup successful!");
          navigate(`/singup-otp/${formData.email}`);
        } else {
          setIsLoading(false);
          toast.error(response.payload?.data?.message || "Signup failed");
        }
      } else if (response.meta.requestStatus === "rejected") {
        setIsLoading(false);
        const errorMessage =
          response.payload?.message ||
          response.payload?.data?.message ||
          "Signup failed. Please try again.";
        toast.error(errorMessage);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Signup error:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  // const handleGoogleSignIn = async () => {
  //   try {
  //     const { email, firstName, lastName, sub, picture } =
  //       await signInWithGoogle();
  //     const data = {
  //       sub,
  //       email,
  //       firstName,
  //       lastName,
  //       picture,
  //       isVerified: true,
  //     };
  //     setIsLoading(true);
  //     const response = await dispatch(storeDataAfterGoogelSingin(data));

  //     if (response.meta.requestStatus === "fulfilled") {
  //       setIsLoading(false);
  //       toast.success("Login Successfully");
  //       const userData = response.payload.data.data;

  //       const webuserId = userData?.webuser?.ROWID;

  //       localStorage.setItem("UserRowId", webuserId);
  //       localStorage.setItem("loggedCustomer", userData);
  //       localStorage.setItem("user", JSON.stringify(userData));

  //       const pendingProductData = localStorage.getItem('pendingProductData');
  //       const redirectPath = localStorage.getItem("redirect");
        
  //       if (pendingProductData) {
  //         setTimeout(() => {
  //           autoAddToCartAfterLogin();
  //         }, 500);
  //       } else {
  //         navigate(redirectPath || "/");
  //       }
  //     } else {
  //       setIsLoading(false);
  //       toast.error(response.payload || "Google sign-in failed");
  //     }
  //   } catch (error) {
  //     setIsLoading(false);
  //     toast.error("Google Sign-in Failed");
  //     console.error("Google sign-in error:", error);
  //   }
  // };

  return (
    <>
      <NavBar />
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="green.500" />
        </div>
      )}
      <div
        className={`login-page-container shadow-sm md:mb-10 sm:mb-10 flex lg:max-w-4xl !max-w-[100%] !min-h-[100vh] mb-0 !mt-0 lg:mx-auto lg:mt-55 lg:mb-36 rounded-3xl overflow-hidden flex-col md:flex-row  ${
          animateEntrance ? "animate-entrance" : ""
        }`}
        style={{ backgroundColor: "#f0f0f0" }}
      >
        <div className="left-panel !hidden  lg:!flex flex-col justify-start p-10 w-full lg:w-1/2">
          <div
            className={`tagline font-serif text-2xl leading-snug mb-3 ${
              animateEntrance ? "animate-slide-in-left" : ""
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            <Heading
              text="Welcome to Umbrona Designs!  "
              className="text-center text-[40px] md:text-2xl lg:text-2xl"
            />
            <Heading
              subText="Manufactured at Our Facility, Delivered to Your Space"
              className="text-center md:text-[24px] lg:text-[24px] mt-2"
            />
          </div>
          <p className="lg:text-[1.2rem]  max-w-auto text-justify leading-relaxed text-black pl-3 text-center -mt-3">
            Custom window blinds engineered for light control, privacy, and durability
          </p>

          <div
            className={`about-us-section rounded-3xl overflow-hidden relative w-full h-[25rem] bg-cover opacity-20 bg-center ${
              animateEntrance ? "animate-slide-in-left" : ""
            }`}
            style={{ backgroundImage: `url(${hero})` }}
          >
            <div className="absolute top-0 left-0 w-full h-full p-6 font-bold flex flex-col rounded-3xl md:text-sm">
              <h1 className="lg:text-2xl md:text-lg font-bold mb-2">
                About us
              </h1>
              <p className="lg:text-lg md:text-sm font-semibold max-w-auto text-justify leading-relaxed text-black">
                Stridum Venture Pvt. Ltd., the company behind Umbrona Designs, carries over two 
                decades of manufacturing expertise. 
              </p>
              <br />
              <p className="lg:text-lg md:text-sm font-semibold max-w-auto text-justify leading-relaxed text-black -mt-6">
                We produce high-quality window blinds, wallpapers, and customized flooring and ceiling 
                solutions for retail, corporate, and government clients, focusing on durability, 
                functionality, and consistent quality.
              </p>
            </div>
          </div>
        </div>

        <div className="right-panel flex flex-col justify-center items-center w-full max-w-[350px] sm:max-w-full md:max-w-full lg:w-1/2 lg:max-w-none mx-auto py-4 min-h-[650px] mt-19 lg:px-4 md:px-1 px-1">
          <div
            className={`form-container !max-w-[700px] md:!max-w-[500px] lg:!max-w-[700px] ${
              isRightPanelActive ? "sign-up-active" : "sign-in-active"
            } ${animateToggle ? "animate-toggle" : ""}`}
          >
            {!isRightPanelActive ? (
              <form onSubmit={handleSignin} className="form">
                <h3 className="text-center text-[#661e33] font-bold mb-4 text-xl md:text-2xl">
                  Login Here
                </h3>
                <label htmlFor="email" className="text-sm md:text-base">Email</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  required
                  onChange={handleChange}
                  className="w-full p-2 text-sm md:text-base"
                />
                <label htmlFor="password" className="text-sm md:text-base">Password</label>
                <div className="password-input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                    required
                    onChange={handleChange}
                    className="w-full p-2 text-sm md:text-base"
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    className="password-toggle-icon password-toggle-animate"
                  >
                    {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
                  </span>
                </div>
                {/* <div className="remember-forgot flex flex-row w-full mb-1 items-start gap-0">
                  <label className="flex items-center gap-2 text-sm md:text-base">
                    <input
                      type="checkbox"
                      name="remember"
                      checked={formData.remember}
                      onChange={handleChange}
                      className=""
                    />
                    &nbsp;Remember me
                  </label>
                </div> */}
                <button type="submit" className="login-button w-full py-2.5 text-sm md:text-base">
                  Login
                </button>
                <div className="forgot-password-link">
                  <Link to="/forgot-password" className="font-semibold signup-prompt text-sm md:text-base">
                    Forgot your password?
                  </Link>
                </div>
                <p className="signup-prompt text-sm md:text-base">
                  Don't have an account?{" "}
                  <button
                    type="button"
                    className="toggle-signup"
                    onClick={() => togglePanel(true)}
                  >
                    Create account
                  </button>
                </p>
              </form>
            ) : (
              <form onSubmit={handleSignup} className="form mt-2">
                <h3 className="text-center text-[#661e33] font-bold mb-4 text-xl md:text-2xl">
                  Create Account
                </h3>

                <label htmlFor="firstName" className="text-sm md:text-base">First Name</label>
                <input
                  type="text"
                  name="firstName"
                  id="firstName"
                  required
                  onChange={handleChange}
                  className="w-full p-2 text-sm md:text-base"
                />

                <label htmlFor="lastName" className="text-sm md:text-base">Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  id="lastName"
                  required
                  onChange={handleChange}
                  className="w-full p-2 text-sm md:text-base"
                />

                <label htmlFor="email" className="text-sm md:text-base">Email</label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  required
                  onChange={handleChange}
                  className="w-full p-2 text-sm md:text-base"
                />

                <label htmlFor="phone" className="text-sm md:text-base">Mobile No.</label>
                <input
                  type="tel"
                  name="phone"
                  id="phone"
                  required
                  onChange={handleChange}
                  className="w-full p-2 text-sm md:text-base"
                />

                <label htmlFor="password" className="text-sm md:text-base">Password</label>
                <div className="password-input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                    required
                    onChange={handleChange}
                    className="w-full p-2 text-sm md:text-base"
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    className="password-toggle-icon password-toggle-animate"
                  >
                    {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
                  </span>
                </div>

                {/* Radio Buttons Section */}
                <div className="mt-1 mb-2">
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6">
                    <label htmlFor="Customer" className="text-sm md:text-base">Customer Type :</label>
                    
                    <div className="flex gap-4">
                      <label className="flex items-center gap-1 cursor-pointer">
                        <input
                          type="radio"
                          name="customerType"
                          value="USER"
                          checked={userType === "USER"}
                          onChange={handleUserTypeChange}
                          className="me-1 text-[#661e33] focus:ring-[#661e33]"
                        />
                        <span className="text-sm md:text-base text-gray-600">User</span>
                      </label>

                      <label className="flex items-center gap-1 cursor-pointer">
                        <input
                          type="radio"
                          name="customerType"
                          value="BUSINESS"
                          checked={userType === "BUSINESS"}
                          onChange={handleUserTypeChange}
                          className="me-1 text-[#661e33] focus:ring-[#661e33]"
                        />
                        <span className="text-sm md:text-base text-gray-600">Business</span>
                      </label>
                    </div>
                  </div>
                </div>

                {/* Conditional Business Fields - Show only when Business is selected */}
                {userType === "BUSINESS" && (
                  <div className="business-fields animate-fadeIn">
                    <label htmlFor="companyName" className="text-sm md:text-base">
                      Company Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="companyName"
                      id="companyName"
                      required={userType === "BUSINESS"}
                      onChange={handleChange}
                      className="w-full p-2 text-sm md:text-base border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#661e33] focus:border-transparent"
                    />

                    <label htmlFor="gstNumber" className="text-sm md:text-base">GST Number </label>
                    <input
                      type="text"
                      name="gstNumber"
                      id="gstNumber"
                      required={userType === "BUSINESS"}
                      onChange={handleChange}
                      className="w-full p-2 text-sm md:text-base border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#661e33] focus:border-transparent"
                      placeholder="22AAAAA0000A1Z5"
                    />
                  </div>
                )}

                <button type="submit" className="signup-button w-full py-2.5 text-sm md:text-base">
                  Sign Up
                </button>

                <p className="signin-prompt text-sm md:text-base">
                  Already have an account?{" "}
                  <button
                    type="button"
                    className="toggle-signin"
                    onClick={() => togglePanel(false)}
                  >
                    Sign in
                  </button>
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;